var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('dialog-scroll-lock', {
    attrs: {
      "width": "500",
      "value": !!_vm.show
    },
    on: {
      "input": function ($event) {
        _vm.show = null;
      }
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "float-right ma-4",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.show = null;
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.mdiClose))])], 1), _c('v-card-title', [_vm._v(_vm._s(_vm.show))]), _vm.show == 'Available fonts' ? _c('v-card-text', _vm._l(_vm.fonts, function (font) {
    return _c('div', {
      staticClass: "my-2",
      style: {
        'font-family': font
      }
    }, [_vm._v(_vm._s(font))]);
  }), 0) : _vm.show == 'User colors' ? _c('v-card-text', _vm._l(_vm.colors, function (color) {
    return _c('div', {
      staticClass: "my-2 d-flex align-center"
    }, [_c('div', {
      staticStyle: {
        "width": "24px",
        "height": "24px"
      },
      style: {
        'background-color': color
      }
    }), _c('div', {
      staticClass: "ml-2"
    }, [_vm._v(_vm._s(color))])]);
  }), 0) : _vm._e()], 1)], 1), _c('h1', {
    staticClass: "mt-6 mb-3 text-h4 text-sm-h3"
  }, [_vm._v("API Documentation")]), _c('p', [_vm._v("We provide an API to allow businesses / organizations to create and manage cards programmatically. This API works in conjunction with our other "), _c('router-link', {
    attrs: {
      "to": {
        name: 'business'
      }
    }
  }, [_vm._v("organization tools")]), _vm._v(", like our analytics and custom branding. See also our documentation for building "), _c('router-link', {
    attrs: {
      "to": {
        name: 'video-template-docs'
      }
    }
  }, [_vm._v("group video themes")]), _vm._v(". Please "), _c('a', {
    attrs: {
      "href": "mailto:contact@ellacard.com"
    }
  }, [_vm._v("contact us")]), _vm._v(" with any questions.")], 1), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h5",
    attrs: {
      "anchor": "table-of-contents",
      "title": "Contents"
    }
  }), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#getting-started"
    }
  }, [_vm._v("Getting started")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#overview"
    }
  }, [_vm._v("Overview")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#user-ids"
    }
  }, [_vm._v("User IDs")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#design-ids"
    }
  }, [_vm._v("Design IDs")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#endpoints"
    }
  }, [_vm._v("Endpoints")]), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#endpoint.auth"
    }
  }, [_vm._v("/auth")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#endpoint.create-order"
    }
  }, [_vm._v("/create-order")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#endpoint.get-order"
    }
  }, [_vm._v("/get-order")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#endpoint.get-order-urls"
    }
  }, [_vm._v("/get-order-urls")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#endpoint.update-order"
    }
  }, [_vm._v("/update-order")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#endpoint.list-orders"
    }
  }, [_vm._v("/list-orders")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#endpoint.cancel-order"
    }
  }, [_vm._v("/cancel-order")])])])]), _c('li', [_c('a', {
    attrs: {
      "href": "#example"
    }
  }, [_vm._v("Example")])])]), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h5",
    attrs: {
      "anchor": "getting-started",
      "title": "Getting started"
    }
  }), _c('p', [_vm._v("First, get your API access key from the API tab in the "), _c('router-link', {
    attrs: {
      "to": {
        name: 'business'
      }
    }
  }, [_vm._v("organization tools")]), _vm._v(" page. You must be an organization administrator to access this page, and your organization must be enrolled in plan that supports API access. The tools there also let you delete and generate new access keys.")], 1), _c('p', [_vm._v("The Ellacard API follows the "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://op-dev.io"
    }
  }, [_vm._v("op-dev")]), _vm._v(" pattern. You interact with the API using JSON remote procedure calls. There is a Python client available that makes it easier to interact with the API by automatically serializing / deserializing requests and managing re-authentication. See the "), _c('code', [_vm._v("curl")]), _vm._v(" example to better understand the raw mechanism / headers for making calls.")]), _c('p', [_vm._v("Please "), _c('a', {
    attrs: {
      "href": "#example"
    }
  }, [_vm._v("see below")]), _vm._v(" for a more comprehensive example of how to use the API.")]), _c('v-tabs', {
    staticClass: "mt-2 mb-4",
    attrs: {
      "background-color": "#0000",
      "show-arrows": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v("Python 3")]), _c('v-tab', [_vm._v("Curl")])], 1), _c('v-tabs-items', {
    staticClass: "mb-6",
    staticStyle: {
      "background-color": "unset"
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('div', [_vm._v("First install the Python client:")]), _c('pre', {
    staticClass: "code mb-4"
  }, [_vm._v("pip install https://pypi.op-dev.io/op-service-client/op-service-client-0.1.0.tar.gz")]), _c('div', [_vm._v("The following Python script connects to the API and lists your orders. Run it to test your connection:")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("#!/usr/bin/env python3\n\n# Set this variable first\nAPI_ACCESS_KEY = …\n\nimport json\nfrom op_service_client import OPServiceClient\n\nclient = OPServiceClient(\n  url='https://api.ellacard.com',\n  auth={ 'route': 'auth', 'params': { 'key': API_ACCESS_KEY } }\n)\n\n# The 'OPServiceClient' will automatically authenticate (and re-authenticate) as needed\noutput = client.call('list-orders')\nprint(json.dumps(output, indent=2))\n")])]), _c('v-tab-item', [_c('div', [_vm._v("The following bash script shows how to use "), _c('code', [_vm._v("curl")]), _vm._v(" to connect to the API, authenticate, and list your orders. Run it to test your connection:")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("#!/usr/bin/env bash\n\n# Set this variable first\nAPI_ACCESS_KEY=…\n\n# First use the API access key to get a JWT. Note that the response to all API endpoints always comes back as JSON (even though it's just a string wrapped in quotes in this case), which is why we use 'jq' to parse it.\nTOKEN=$(curl -s -X POST -H \"Content-Type: application/json\" https://api.ellacard.com/auth -d \"{ \\\"key\\\": \\\"$API_ACCESS_KEY\\\" }\" | jq -r .)\n\ncurl -s -X POST -H \"Content-Type: application/json\" -H \"Authorization: Bearer $TOKEN\" https://api.ellacard.com/list-orders | jq .\n")])])], 1), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h5",
    attrs: {
      "anchor": "overview",
      "title": "Overview"
    }
  }), _c('p', [_vm._v("The Ellacard API lets you create, get, list, update, and cancel orders. All your orders will be tied to your organization (thus they'll automatically respect any custom branding you have enabled), and each order must be owned by an individual user in your organization. This allows you to use the Ellacard account tools to manually manage any individual order if necessary. Please "), _c('a', {
    attrs: {
      "href": "mailto:contact@ellacard.com"
    }
  }, [_vm._v("contact us")]), _vm._v(" to create an Ellacard organization account, or to add API access to your existing organization account.")]), _c('p', [_vm._v("There are two primary ways users interact with Ellacard orders: via the order-sign and order-open views. Note that both of these views can be entirely embedded on your own website (see the \"Embedding\" tab in the "), _c('router-link', {
    attrs: {
      "to": {
        name: 'business'
      }
    }
  }, [_vm._v("organization tools")]), _vm._v("). The order-sign view allows anyone to add content to the card without an account. Note the \"allow_gift_cards\" and \"allow_replace_designs\" flags in the create-order and update-order endpoints that give you some control over the features available in the order-sign interface. The owner of the order can also \"lock\" the order to prevent others from being able to add / edit content via the order-sign interface (this happens automatically when we deliver an order).")], 1), _c('p', [_vm._v("You can set your orders to auto-send or not by specifying a \"send_at\" time. In the former case, each recipient you specify will receive a unique link that leads to the order-open view, which allows us to track which recipients have actually opened the order. We also generate a separete unique link that also leads to the order-open view, which you can distribute yourself.")]), _c('p', [_vm._v("Note that you can update any of the order details at any time, unless the order has already been auto-sent.")]), _c('p', [_vm._v("We provide a dashboard that summarizes all your organization's orders. It is accessible only to organization administrators in the orders tab in the "), _c('router-link', {
    attrs: {
      "to": {
        name: 'business'
      }
    }
  }, [_vm._v("organization tools")]), _vm._v(" page. You can also retrieve a list of your organization's orders via the list-orders API (using the appropriate access key).")], 1), _c('p', [_vm._v("You can test your integration with the API using the sandbox access keys for free with all features available, but all associated orders will have a watermark. When placing an order in production, your organization's credits / discounts will be automatically applied.")]), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h5",
    attrs: {
      "anchor": "user-ids",
      "title": "User IDs"
    }
  }), _c('p', [_vm._v("Each order you create must be owned by a user who is a member of your organization. To find a user's ID, open the \"Users\" tab in the "), _c('router-link', {
    attrs: {
      "to": {
        name: 'business'
      }
    }
  }, [_vm._v("organization tools")]), _vm._v(" and click the info icon in the corresponding row.")], 1), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h5",
    attrs: {
      "anchor": "design-ids",
      "title": "Design IDs"
    }
  }), _c('p', [_vm._v("You can specify a design ID when creating an order. To find the ID for one of the designs in our "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog'
      }
    }
  }, [_vm._v("card catalog")]), _vm._v(", just select a design, then copy the URL suffix – https://ellacard.com/cards/"), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx")]), _vm._v(". Note that you can also use your own custom designs, such as those created via the "), _c('router-link', {
    attrs: {
      "to": {
        name: 'img-to-design'
      }
    }
  }, [_vm._v("create reusable card")]), _vm._v(" tool – the resulting link has a similar suffix.")], 1), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h5",
    attrs: {
      "anchor": "endpoints",
      "title": "Endpoints"
    }
  }), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h6",
    attrs: {
      "anchor": "endpoint.auth",
      "title": "/auth"
    }
  }), _c('p', [_vm._v("Uses your access key to get a temporary JWT that can be used to call other APIs. You can generate and delete access keys in the \"API\" tab in the "), _c('router-link', {
    attrs: {
      "to": {
        name: 'business'
      }
    }
  }, [_vm._v("organization tools")]), _vm._v(".")], 1), _c('p', [_vm._v("Note that the output JWT will have the \"exp\" property set, so you can check if you need to re-authenticate before making a service call (the Python 3 client does this automatically). You can use "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://jwt.io/"
    }
  }, [_vm._v("this tool")]), _vm._v(" to see the information we encode in the JWT.")]), _c('v-row', {
    staticClass: "pb-12"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Input")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("{\n  \"key\": non_empty_str\n}\n")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Output")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("non_empty_str\n")])])], 1), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h6",
    attrs: {
      "anchor": "endpoint.create-order",
      "title": "/create-order"
    }
  }), _c('p', [_vm._v("Creates an order with the specified details and returns the order ID in addition to the order-sign and order-open links, which will respect any custom branding your organization has set up.")]), _c('v-row', {
    staticClass: "pb-12"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Input")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("{\n  \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `user_id`,
          required: true,
          msg: `Must correspond to a member of your organization. You can get a user's ID by clicking on the info button in the 'User ID' column in the 'Users' tab in the organization tools.`
        });
      }
    }
  }, [_vm._v("user_id")]), _vm._v("\": uuid_str,\n  \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `design_id`,
          msg: `If omitted or set to null, this order will be created using the blank design.`
        });
      }
    }
  }, [_vm._v("[design_id]")]), _vm._v("\": nullable(uuid_str),\n  \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `from`,
          msg: `Who the card is from. Will be displayed to signers in the order-sign view and on the envelope in the order-open view. It will also be included in any delivery emails / texts sent by Ellacard.`
        });
      }
    }
  }, [_vm._v("[from]")]), _vm._v("\": nullable(non_empty_str),\n  \""), _c('a', {
    on: {
      "click": function ($event) {
        _vm.popUp({
          title: `recipients`,
          msg: `The recipients of the order. Only one of 'email' or 'text' should be set per recipient. Only relevant if the 'send_at' time is also set. Cannot exceed 500 recipients per order.<br><br>Note that only US phone numbers are currently supported, and should be formatted as '+1##########' or '(###) ###-####'.`
        });
      }
    }
  }, [_vm._v("[recipients]")]), _vm._v("\": nullable([\n    {\n      \"to\": nullable(non_empty_str),\n      \"[email]\": email_address,\n      \"[text]\": us_phone_number\n    },\n    …\n  ]),\n  \""), _c('a', {
    on: {
      "click": function ($event) {
        _vm.popUp({
          title: `send_at`,
          msg: `The time at which Ellacard should deliver the order to the recipients. Omit or set to null to not send the order automatically. Any value in the past will cause the order to be delivered immediately. Should be a string formatted as '2020-01-01T00:00:00Z' or '2020-01-01T00:00:00+00:00' (must include timezone).`
        });
      }
    }
  }, [_vm._v("[send_at]")]), _vm._v("\": nullable(iso_datetime_str),\n  \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `allow_gift_cards`,
          msg: `Set to true to allow users to add gift cards to this order.`
        });
      }
    }
  }, [_vm._v("[allow_gift_cards]")]), _vm._v("\": bool,\n  \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `allow_replace_design`,
          msg: `Set to true to allow users to change the cover design of this order.`
        });
      }
    }
  }, [_vm._v("[allow_replace_design]")]), _vm._v("\": bool,\n  \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `allow_universal_editing`,
          msg: `Set to true to allow any user to edit / delete any other user's blobs as opposed to just the owner of this order.`
        });
      }
    }
  }, [_vm._v("[allow_universal_editing]")]), _vm._v("\": bool\n}\n")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Output")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("{\n  \"order_id\": uuid_str,\n  \"order\": {\n    \"from\": nullable(str),\n    \"recipients\": nullable([\n      {\n        \"to\": nullable(non_empty_str),\n        \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `email`,
          msg: `Only one of 'email' or 'text' will be set.`
        });
      }
    }
  }, [_vm._v("[email]")]), _vm._v("\": email_address,\n        \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `text`,
          msg: `Only one of 'email' or 'text' will be set.`
        });
      }
    }
  }, [_vm._v("[text]")]), _vm._v("\": us_phone_number\n      },\n      …\n    ]),\n    \"send_at\": nullable(iso_datetime_str),\n    \"allow_gift_cards\": bool,\n    \"allow_replace_design\": bool,\n    \"allow_universal_editing\": bool\n  },\n  \"sign_url\": non_empty_str,\n  \"open_url\": non_empty_str\n}\n")])])], 1), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h6",
    attrs: {
      "anchor": "endpoint.get-order",
      "title": "/get-order"
    }
  }), _c('p', [_vm._v("Retrieves an order that your organization has created via the API.")]), _c('v-row', {
    staticClass: "pb-12"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Input")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("{\n  \"order_id\": uuid_str\n}\n")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Output")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("{\n  \"from\": nullable(str),\n  \"recipients\": nullable([\n    {\n      \"to\": nullable(non_empty_str),\n      \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `email`,
          msg: `Only one of 'email' or 'text' will be set.`
        });
      }
    }
  }, [_vm._v("[email]")]), _vm._v("\": email_address,\n      \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `text`,
          msg: `Only one of 'email' or 'text' will be set.`
        });
      }
    }
  }, [_vm._v("[text]")]), _vm._v("\": us_phone_number\n    },\n    …\n  ]),\n  \"send_at\": nullable(iso_datetime_str),\n  \"allow_gift_cards\": bool,\n  \"allow_replace_design\": bool,\n  \"allow_universal_editing\": bool\n}\n")])])], 1), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h6",
    attrs: {
      "anchor": "endpoint.get-order-urls",
      "title": "/get-order-urls"
    }
  }), _c('p', [_vm._v("Retrieves the order-sign and order-open URLs for an order that your organization has created via the API. Note that these URLs will respect any custom branding your organization has set up.")]), _c('v-row', {
    staticClass: "pb-12"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Input")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("{\n  \"order_id\": uuid_str\n}\n")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Output")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("{\n  \"sign_url\": non_empty_str,\n  \"open_url\": non_empty_str\n}\n")])])], 1), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h6",
    attrs: {
      "anchor": "endpoint.update-order",
      "title": "/update-order"
    }
  }), _c('p', [_vm._v("Updates an order that your organization has created via the API with the specified details. Note that this API can also be used to lock / unlock an order, which prevents other users from editing the card (the owner can always make edits).")]), _c('v-row', {
    staticClass: "pb-12"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Input")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("{\n  \"order_id\": uuid_str,\n  \"[order]\": {\n    \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `user_id`,
          required: true,
          msg: `Must correspond to a member of your organization. You can get a user's ID by clicking on the info button in the 'User ID' column in the 'Users' tab in the organization tools.`
        });
      }
    }
  }, [_vm._v("user_id")]), _vm._v("\": uuid_str,\n    \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `design_id`,
          msg: `If omitted or set to null, this order will be created using the blank design.`
        });
      }
    }
  }, [_vm._v("[design_id]")]), _vm._v("\": nullable(uuid_str),\n    \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `from`,
          msg: `Who the card is from. Will be displayed to signers in the order-sign view and on the envelope in the order-open view. It will also be included in any delivery emails / texts sent by Ellacard.`
        });
      }
    }
  }, [_vm._v("[from]")]), _vm._v("\": nullable(non_empty_str),\n    \""), _c('a', {
    on: {
      "click": function ($event) {
        _vm.popUp({
          title: `recipients`,
          msg: `The recipients of the order. Only one of 'email' or 'text' should be set per recipient. Only relevant if the 'send_at' time is also set. Cannot exceed 500 recipients per order.<br><br>Note that only US phone numbers are currently supported, and should be formatted as '+1##########' or '(###) ###-####'.`
        });
      }
    }
  }, [_vm._v("[recipients]")]), _vm._v("\": nullable([\n      {\n        \"to\": nullable(non_empty_str),\n        \"[email]\": email_address,\n        \"[text]\": us_phone_number\n      },\n      …\n    ]),\n    \""), _c('a', {
    on: {
      "click": function ($event) {
        _vm.popUp({
          title: `send_at`,
          msg: `The time at which Ellacard should deliver the order to the recipients. Omit or set to null to not send the order automatically. Any value in the past will cause the order to be delivered immediately. Should be a string formatted as '2020-01-01T00:00:00Z' or '2020-01-01T00:00:00+00:00' (must include timezone).`
        });
      }
    }
  }, [_vm._v("[send_at]")]), _vm._v("\": nullable(iso_datetime_str),\n    \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `allow_gift_cards`,
          msg: `Set to true to allow users to add gift cards to this order.`
        });
      }
    }
  }, [_vm._v("[allow_gift_cards]")]), _vm._v("\": bool,\n    \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `allow_replace_design`,
          msg: `Set to true to allow users to change the cover design of this order.`
        });
      }
    }
  }, [_vm._v("[allow_replace_design]")]), _vm._v("\": bool,\n    \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `allow_universal_editing`,
          msg: `Set to true to allow any user to edit / delete any other user's blobs as opposed to just the owner of this order.`
        });
      }
    }
  }, [_vm._v("[allow_universal_editing]")]), _vm._v("\": bool\n  },\n  \""), _c('a', {
    on: {
      "click": function ($event) {
        _vm.popUp({
          title: `lock`,
          msg: `Control whether or not other users (not the owner) can edit this order via the order-sign interface. Note that orders are automatically locked once auto-sent by Ellacard, but can be unlocked again if needed.`
        });
      }
    }
  }, [_vm._v("[lock]")]), _vm._v("\": bool\n}\n")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Output")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("{\n  \"from\": nullable(str),\n  \"recipients\": nullable([\n    {\n      \"to\": nullable(non_empty_str),\n      \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `email`,
          msg: `Only one of 'email' or 'text' will be set.`
        });
      }
    }
  }, [_vm._v("[email]")]), _vm._v("\": email_address,\n      \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `text`,
          msg: `Only one of 'email' or 'text' will be set.`
        });
      }
    }
  }, [_vm._v("[text]")]), _vm._v("\": us_phone_number\n    },\n    …\n  ]),\n  \"send_at\": nullable(iso_datetime_str),\n  \"allow_gift_cards\": bool,\n  \"allow_replace_design\": bool,\n  \"allow_universal_editing\": bool\n}\n")])])], 1), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h6",
    attrs: {
      "anchor": "endpoint.list-orders",
      "title": "/list-orders"
    }
  }), _c('p', [_vm._v("Lists all the orders that your organization has created via the API.")]), _c('v-row', {
    staticClass: "pb-12"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Input")]), _c('pre', {
    staticClass: "code"
  })]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Output")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("[\n  {\n    \"order_id\": uuid_str,\n    \"order\": {\n      \"from\": nullable(str),\n      \"recipients\": nullable([\n        {\n          \"to\": nullable(non_empty_str),\n          \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `email`,
          msg: `Only one of 'email' or 'text' will be set.`
        });
      }
    }
  }, [_vm._v("[email]")]), _vm._v("\": email_address,\n          \""), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.popUp({
          title: `text`,
          msg: `Only one of 'email' or 'text' will be set.`
        });
      }
    }
  }, [_vm._v("[text]")]), _vm._v("\": us_phone_number\n        },\n        …\n      ]),\n      \"send_at\": nullable(iso_datetime_str),\n      \"allow_gift_cards\": bool,\n      \"allow_replace_design\": bool,\n      \"allow_universal_editing\": bool\n    }\n  },\n  …\n]\n")])])], 1), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h6",
    attrs: {
      "anchor": "endpoint.cancel-order",
      "title": "/cancel-order"
    }
  }), _c('p', [_vm._v("Cancels an order that your organization has created via the API. Orders may not be cancelled after they have already been auto-sent by Ellacard. Cancelled orders cannot be viewed in either the order-sign or order-open interfaces.")]), _c('v-row', {
    staticClass: "pb-12"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Input")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("{\n  \"order_id\": uuid_str\n}\n")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "overline short"
  }, [_vm._v("Output")]), _c('pre', {
    staticClass: "code"
  })])], 1), _c('faq-header', {
    staticClass: "mt-12 mb-2 text-h5",
    attrs: {
      "anchor": "example",
      "title": "Example"
    }
  }), _c('p', [_vm._v("This script will create an order, print the relevant links to the order-sign and order-open interfaces, then update the order to set it to send right away to the specified recipient.")]), _c('v-tabs', {
    staticClass: "mt-2 mb-4",
    attrs: {
      "background-color": "#0000",
      "show-arrows": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v("Python 3")]), _c('v-tab', [_vm._v("Curl")])], 1), _c('v-tabs-items', {
    staticClass: "mb-6",
    staticStyle: {
      "background-color": "unset"
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('pre', {
    staticClass: "code mb-4"
  }, [_vm._v("pip install https://pypi.op-dev.io/op-service-client/op-service-client-0.1.0.tar.gz")]), _c('pre', {
    staticClass: "code"
  }, [_vm._v("#!/usr/bin/env python3\n\n# Set these variables first\nAPI_ACCESS_KEY = …\nUSER_ID = …\nRECIPIENT_EMAIL_ADDRESS = …\n\nimport json\nimport time\nfrom op_service_client import OPServiceClient\n\nclient = OPServiceClient(\n  url='https://api.ellacard.com',\n  auth={ 'route': 'auth', 'params': { 'key': API_ACCESS_KEY } }\n)\n\n# Create an order using the blank design. Note that we haven't set this order to auto-send.\ncreate_order_output = client.call('create-order', { 'user_id': USER_ID })\nprint('Order structure after create-order:')\nprint(json.dumps(create_order_output['order'], indent=2))\n\norder_id = create_order_output['order_id']\n\n# You could share / display the \"sign_url\" to let others contribute to the order\nprint('Contribute to the order using this link:')\nprint(create_order_output['sign_url'])\n\n# Or you could share the order-open URL to let others open the order\nprint('Open the order using this link:')\nprint(create_order_output['open_url'])\n\n# Let's update the order and set it to send automatically\nupdate_order_output = client.call(\n  'update-order',\n  {\n    'order_id': order_id,\n    'order': {\n      'recipients': [ { 'to': None, 'email': RECIPIENT_EMAIL_ADDRESS } ],\n      'send_at': '2021-01-01T00:00:00Z'\n    }\n  }\n)\nprint('Order structure after update-order:')\nprint(json.dumps(update_order_output, indent=2))\n\n# Now that the order has been sent, any further attempts to update the order data will fail. If you navigate to the 'sign_url' (as any user other than the one who created the order), you'll see that it has been locked and you are unable to contribute to it.\n\n# Finaly, let's list all of our orders\nlist_orders_output = client.call('list-orders')\nprint('Output of list-orders:')\nprint(json.dumps(list_orders_output, indent=2))\n")])]), _c('v-tab-item', [_c('pre', {
    staticClass: "code"
  }, [_vm._v("#!/usr/bin/env bash\n\n# Set these variables first\nAPI_ACCESS_KEY=…\nUSER_ID=…\nRECIPIENT_EMAIL_ADDRESS=…\n\n# First use the API access key to get a JWT\nTOKEN=$(curl -s -X POST -H \"Content-Type: application/json\" https://api.ellacard.com/auth -d \"{ \\\"key\\\": \\\"$API_ACCESS_KEY\\\" }\" | jq -r .)\n\n# Create an order using the blank design. Note that we haven't set this order to auto-send.\nCREATE_ORDER_OUTPUT=$(curl -s -X POST -H \"Content-Type: application/json\" -H \"Authorization: Bearer $TOKEN\" https://api.ellacard.com/create-order -d \"{ \\\"user_id\\\": \\\"$USER_ID\\\" }\")\necho \"Order structure after create-order:\"\necho \"$CREATE_ORDER_OUTPUT\" | jq .order\n\nORDER_ID=$(echo \"$CREATE_ORDER_OUTPUT\" | jq -r .order_id)\n\n# You could share / display the \"sign_url\" to let others contribute to the order\necho \"Contribute to the order using this link:\"\necho \"$CREATE_ORDER_OUTPUT\" | jq -r .sign_url\n\n# Or you could share the order-open URL to let others open the order\necho \"Open the order using this link:\"\necho \"$CREATE_ORDER_OUTPUT\" | jq -r .open_url\n\n# Let's update the order and set it to send automatically\nUPDATE_ORDER_OUTPUT=$(curl -s -X POST -H \"Content-Type: application/json\" -H \"Authorization: Bearer $TOKEN\" https://api.ellacard.com/update-order -d \"{ \\\"order_id\\\": \\\"$ORDER_ID\\\", \\\"order\\\": { \\\"recipients\\\": [ { \\\"to\\\": null, \\\"email\\\": \\\"$RECIPIENT_EMAIL_ADDRESS\\\" } ], \\\"send_at\\\": \\\"2021-01-01T00:00:00Z\\\" } }\")\necho \"Order structure after update-order:\"\necho \"$UPDATE_ORDER_OUTPUT\" | jq .\n\n# Now that the order has been sent, any further attempts to update the order data will fail. If you navigate to the 'sign_url' (as any user other than the one who created the order), you'll see that it has been locked and you are unable to contribute to it.\n\n# Finaly, let's list all of our orders\nLIST_ORDERS_OUTPUT=$(curl -s -X POST -H \"Content-Type: application/json\" -H \"Authorization: Bearer $TOKEN\" https://api.ellacard.com/list-orders)\necho \"Output of list-orders:\"\necho \"$LIST_ORDERS_OUTPUT\" | jq .\n")])])], 1), _c('p', {
    staticClass: "mt-12"
  }, [_vm._v("Please "), _c('a', {
    attrs: {
      "href": "mailto:contact@ellacard.com"
    }
  }, [_vm._v("contact us")]), _vm._v(" with any additional questions.")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }